<template>
  <div class="partner">
    <div class="partner_title">应用表盘开发<br />合作伙伴</div>
    <div class="partner_content">
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_1.png"
        alt="partner_img1"
        style="width: 110px; height: 45px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_2.png"
        alt="partner_img1"
        style="width: 120px; height: 45px"
      />
    </div>
    <div class="partner_content" style="margin-top: 10px">
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_3.png"
        alt="partner_img1"
        style="width: 100px; height: 45px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_4.png"
        alt="partner_img1"
        style="width: 96px; height: 45px"
      />
    </div>
    <div class="partner_content" style="margin-top: 10px">
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_5.png"
        alt="partner_img1"
        style="width: 130px; height: 45px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_6.png"
        alt="partner_img1"
        style="width: 113px; height: 45px"
      />
    </div>
    <div class="partner_content" style="margin-top: 10px">
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_7.png"
        alt="partner_img1"
        style="width: 117px; height: 45px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_14.png"
        alt="partner_img1"
        style="width: 60px; height: 45px"
      />
    </div>
    <div class="partner_title">手表整机伙伴</div>
    <div class="partner_content">
      <!-- <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_8.png"
        alt="partner_img1"
        style="width: 72px; height: 65px"
      /> -->
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_10.png"
        alt="partner_img1"
        style="width: 121px; height: 65px"
      />
    </div>
    <div class="partner_content" style="margin-top: 10px">
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_9.png"
        alt="partner_img1"
        style="width: 73px; height: 65px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_11.png"
        alt="partner_img1"
        style="width: 146px; height: 45px"
      />
    </div>
    <div class="partner_content" style="margin-top: 10px">
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_12.png"
        alt="partner_img1"
        style="width: 116px; height: 45px"
      />
      <img
        class="partner_logo"
        src="@/assets/img/home_partner/partner_logo_13.png"
        alt="partner_img1"
        style="width: 116px; height: 45px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileHomePartner",
};
</script>

<style scoped>
.partner {
  width: 100vw;
  padding-bottom: 65px;
}
.partner_title {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 24px;
  color: #1f2937;
  text-align: center;
  padding-top: 60px;
  margin-bottom: 48px;
}
.partner_content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.partner_logo {
  margin: 0 9px;
}
</style>

